import * as ReactDOM from 'react-dom';

export function addElementToClassName(className: string, component: JSX.Element) {
    const elements = document.getElementsByClassName(className);
    Array.from(elements).forEach(element => ReactDOM.render(component, element));
}
